import { Navigate, useParams } from "react-router-dom";
import InviteAcceptLayout from "../components/auth/invite-accept-layout";

function AcceptInvitePage() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <Navigate to="/download-app" replace />;
  }

  return <InviteAcceptLayout slug={slug} />;
}

export default AcceptInvitePage;
